import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar, UserLink } from "@/components/UserBits";

const MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
const MEDAL = ["🥇", "🥈", "🥉"];

export function DuelLeaderboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/duels/leaderboard").then(({ data }) => setD(data)).catch(() => setD({ top: [] })); }, []);
  if (!d) return null;
  return (
    <section className="rounded-[2rem] bg-white border border-pink-100 p-5 sm:p-7 shadow-sm space-y-4" data-testid="duel-leaderboard">
      <div className="flex items-start gap-3">
        <span className="w-12 h-12 shrink-0 rounded-2xl bg-gradient-to-br from-amber-400 to-rose-500 flex items-center justify-center"><Crown className="w-6 h-6 text-white" /></span>
        <div>
          <h2 className="font-display text-xl font-extrabold">Duell-Rangliste {MONTHS[new Date().getMonth()]}</h2>
          <p className="text-sm text-slate-500">Wer am Monatsende die meisten Duelle gewonnen hat, wird <b className="text-orange-600">⚔️👑 Duell-König</b> – das Abzeichen bleibt für immer im Profil.</p>
        </div>
      </div>
      {d.me && <p className="text-sm font-bold text-rose-600" data-testid="duel-leaderboard-me">Dein Platz: #{d.me.rank} · {d.me.wins} {d.me.wins === 1 ? "Sieg" : "Siege"}</p>}
      {d.top.length ? (
        <ol className="space-y-2">
          {d.top.map((r) => (
            <li key={r.user.user_id} className={`flex items-center gap-3 rounded-2xl p-2.5 ${r.rank === 1 ? "bg-amber-50 border border-amber-200" : "bg-slate-50"}`} data-testid={`duel-rank-${r.rank}`}>
              <span className="w-7 text-center font-extrabold text-slate-500">{MEDAL[r.rank - 1] || r.rank}</span>
              <UserAvatar userId={r.user.user_id} name={r.user.name} picture={r.user.picture} size="w-9 h-9" text="text-xs" />
              <UserLink id={r.user.user_id} className="flex-1 min-w-0 truncate font-semibold text-sm">{r.user.name}</UserLink>
              <span className="text-right"><span className="block font-extrabold text-slate-900">{r.wins} {r.wins === 1 ? "Sieg" : "Siege"}</span><span className="text-[11px] text-slate-400">+{r.won} Punkte</span></span>
            </li>
          ))}
        </ol>
      ) : <p className="text-sm text-slate-500 rounded-2xl bg-slate-50 p-4" data-testid="duel-leaderboard-empty">Diesen Monat wurde noch kein Duell entschieden – fordere jetzt einen Freund heraus!</p>}
    </section>
  );
}
